import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import GoogleAuthButton from "@/components/GoogleAuthButton";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [refCode, setRefCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const r = params.get("ref");
    if (r) setRefCode(r.toUpperCase());
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    const r = await register(email, password, name, refCode || undefined);
    setLoading(false);
    if (r.ok) { toast.success("Welcome to African Bridge Media"); nav("/"); }
    else toast.error(r.error);
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="rounded-2xl bg-white border border-[#E2DED0] p-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">Join the community</div>
        <h1 className="font-display text-3xl text-[#1E3A2F] mt-1">Create your account</h1>
        {refCode && (
          <div className="mt-4 inline-flex items-center gap-2 abm-chip !bg-[#DDA74A]/15 !text-[#8a5b1a] !border-[#DDA74A]/40" data-testid="signup-ref-notice">
            <Gift className="w-3 h-3" /> Invited by a member · code {refCode}
          </div>
        )}
        <div className="mt-6">
          <GoogleAuthButton label="Sign up with Google" />
        </div>
        <div className="my-5 flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-[#5C5C5C]">
          <span className="flex-1 h-px bg-[#E2DED0]" /> or with email <span className="flex-1 h-px bg-[#E2DED0]" />
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Name</Label>
            <Input data-testid="signup-name" required value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="signup-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div>
            <Label>Referral code (optional)</Label>
            <Input data-testid="signup-refcode" value={refCode} onChange={(e) => setRefCode(e.target.value.toUpperCase())} placeholder="Paste a friend's code" />
          </div>
          <Button data-testid="signup-submit" type="submit" disabled={loading} className="abm-btn-primary rounded-full w-full h-11">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <div className="mt-5 text-sm text-[#5C5C5C]">
          Already a member? <Link to="/login" className="text-[#C05A3D] font-medium">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
